const phoneRegEx: RegExp = /^(0(1[0-9]|2|3[1-3]|4[1-4]|5[1-5]|6[1-4]))([\d|\*]{3,4})([\d|\*]{4})$/;

export function phoneFormat(value: string) {
  if (!value) {
    return "";
  }

  const phone = value.match(phoneRegEx);
  let output;

  if (phone) {
    output = `${phone[1]}-${phone[3]}-${phone[4]}`;
  }

  return output ? output : value;
}

export function parsePhoneFormat(value: string) {
  if (!value) {
    return "";
  }

  const phone = value.replace(/-/g, "");

  return phone;
}
